import { ProcessTypes } from 'components/VerifyCodeSend';
import { SecurityActionType } from './type';

export const processType: Record<SecurityActionType, ProcessTypes> = {
    modifyPhone: 'modify_phone',
    modifyEmail: 'modify_email',
    modifyPassword: 'modify_login_password',
    upgradePassword: 'update_login_password',
    bindEmail: 'bind_email',
    bindPhone: 'bind_phone',
    activeEmail: 'modify_email',
    linkAccount: 'retrieve_ib_password',
    mfaEnable: 'mfa_enable'
};

export const eventType: Record<SecurityActionType, string> = {
    modifyPhone: '手机认证_修改',
    modifyEmail: '邮箱认证_修改',
    modifyPassword: '登录密码_修改',
    activeEmail: '邮箱认证_认证',
    upgradePassword: '登录密码_更新',
    bindEmail: '设置邮箱',
    bindPhone: '设置手机号',
    linkAccount: 'Retrieve Initial Password',
    mfaEnable: '开启两步验证'
};

export const eventName: Record<SecurityActionType, string> = {
    modifyPhone: '修改',
    modifyEmail: '修改',
    modifyPassword: '登录密码修改',
    activeEmail: '修改',
    upgradePassword: '登录密码更新',
    bindEmail: '设置',
    bindPhone: '设置',
    linkAccount: '设置',
    mfaEnable: '设置'
};
